
import React from 'react';
import {View, Text, TouchableOpacity} from 'react-native';
import {noticeStyles, noticeTones} from './boxChampNoticeStyles';

const verdictOf = payload => {
  if (!payload) return null;
  if (payload.result && typeof payload.result === 'object') return payload.result;
  return payload;
};

export const isSetAsideRejection = payload => {
  const verdict = verdictOf(payload);
  return Boolean(
    verdict && verdict.status === false && verdict.data && verdict.data.set_aside,
  );
};

export const setAsideMessage = payload => {
  if (!isSetAsideRejection(payload)) return '';
  const verdict = verdictOf(payload);
  return (verdict.error_messages || [])[0] || '';
};

// testID is overridable so the escalated copy (rendered above the pop-up overlays in
// scanpack_item.js) is addressable separately from the in-flow one. Defaults preserve
// every existing caller and test unchanged.
export default function BoxChampSetAsideNotice({
  message,
  onDismiss,
  tone = 'warning',
  testID = 'boxchamp-set-aside-notice',
  textTestID = 'boxchamp-set-aside-text',
}) {
  if (!message) return null;
  const palette = noticeTones[tone] || noticeTones.warning;

  return (
    <View
      testID={testID}
      style={[noticeStyles.banner, {backgroundColor: palette.background}]}>
      <View style={{flexDirection: 'row', alignItems: 'center'}}>
        <Text
          testID={textTestID}
          style={[noticeStyles.text, {color: palette.text, flex: 1}]}>
          {message}
        </Text>
        {!!onDismiss && (
          <TouchableOpacity
            testID="boxchamp-set-aside-dismiss"
            onPress={onDismiss}
            style={{paddingHorizontal: 8, paddingVertical: 2}}>
            <Text style={[noticeStyles.text, {color: palette.text}]}>✕</Text>
          </TouchableOpacity>
        )}
      </View>
    </View>
  );
}
